export default function OperationGuide() {
  return (
    <section id="operation" className="py-24 bg-gradient-to-b from-orange-50 to-white relative overflow-hidden">
      {/* 배경 장식 */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-50 rounded-full blur-3xl opacity-40"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-30"></div>
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">운영 및 공간이용 안내</h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto mb-4"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            PLAY PLACE의 효율적인 운영 시스템과 편안한 공간 이용 방법을 안내합니다
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* 운영안내 */}
          <div className="group">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="mb-8">
                <div className="relative w-full h-48 mb-8 rounded-2xl overflow-hidden">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/1b1056a4f2e4fa0432f15bc522973427.jpg"
                    alt="운영안내"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-orange-900/20 to-transparent"></div>
                </div>
                
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-settings-3-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 ml-4">운영안내</h3>
                </div>
                
                <p className="text-gray-700 text-lg mb-8">
                  PLAY PLACE는 공간 이용을 중심으로 운영됩니다.
                </p>
              </div>
              
              <div className="space-y-5">
                <div className="flex items-start bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-2 text-lg">공간 중심 구조</h4>
                    <p className="text-gray-600">효율적인 공간 운영 시스템</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-2 text-lg">단순한 이용 방식</h4>
                    <p className="text-gray-600">복잡하지 않은 명확한 이용 구조</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-2 text-lg">안정적인 운영 기준</h4>
                    <p className="text-gray-600">검증된 운영 시스템</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* 공간 이용안내 */}
          <div className="group">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300">
              <div className="mb-8">
                <div className="relative w-full h-48 mb-8 rounded-2xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=People%20enjoying%20comfortable%20modern%20space%2C%20relaxed%20social%20environment%2C%20friends%20gathering%20in%20cozy%20lounge%2C%20natural%20interaction%2C%20warm%20inviting%20interior%2C%20contemporary%20furniture%2C%20orange%20warm%20lighting%2C%20casual%20friendly%20atmosphere&width=600&height=400&seq=space-usage-guide-1&orientation=landscape"
                    alt="공간 이용안내"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent"></div>
                </div>
                
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-gray-700 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-user-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 ml-4">공간 이용안내</h3>
                </div>
                
                <p className="text-gray-700 text-lg mb-8">
                  이용자는 공간에 입장 후 자유롭게 머무르며 이용합니다.
                </p>
              </div>
              
              <div className="space-y-5">
                <div className="flex items-start bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-2 text-lg">개방형 구조</h4>
                    <p className="text-gray-600">자유로운 공간 활용</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-2 text-lg">자연스러운 참여 동선</h4>
                    <p className="text-gray-600">편안한 이용 환경</p>
                  </div>
                </div>
                
                <div className="flex items-start bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-white"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-2 text-lg">장시간 체류 적합 설계</h4>
                    <p className="text-gray-600">오래 머물러도 편안한 공간</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}